import { useEffect, useState } from "react";
import inventoryManagementService from "services/inventory-items-service";

import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";
import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import MiniStatisticsCard from "e4acomponents/Cards/StatisticsCards/MiniStatisticsCard";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Footer from "e4acomponents/Footer";

import RecentChanges from "layouts/dashboard/components/RecentChanges";
import AwaitingApproval from "layouts/dashboard/components/Awaiting Approval";
import StockDiversity from "layouts/dashboard/components/StockDiversity";

export default function Dashboard() {
    const [inventoryStats, setInventoryStats] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const response = await inventoryManagementService.getInventoryStats();
                const inventoryStatsData = response.data.stats;
                inventoryStatsData["Smith Falls"]["value"] = inventoryStatsData["Smith Falls"]["value"].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                inventoryStatsData["Kanata"]["value"] = inventoryStatsData["Kanata"]["value"].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                inventoryStatsData["finished_goods"]["value"] = inventoryStatsData["finished_goods"]["value"].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                setInventoryStats(inventoryStatsData);
            } catch (error) {
                console.error("Error fetching recent changes:", error);
            }
        })();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox py={3}>
                {/* Statistics cards */}
                {(inventoryStats === null) ? (
                    <MDBox
                        p={3}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                    >
                        <CircularProgress />
                    </MDBox>
                ) : (
                    <Grid container spacing={3}>
                        {/* Finished Goods Inventory Stats */}
                        <Grid item xs={12} md={6} lg={6}>
                            <MiniStatisticsCard
                                title={{ text: "Total Finished Goods" }}
                                count={inventoryStats["finished_goods"]["quantity"]}
                                icon={{ color: "warning", component: "inventory_2" }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <MiniStatisticsCard
                                title={{ text: "Total Value Finished Goods" }}
                                count={`C$ ${inventoryStats["finished_goods"]["value"]}`}
                                icon={{ color: "warning", component: "inventory_2" }}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                            <MiniStatisticsCard
                                title={{ text: "Total Products SF" }}
                                count={inventoryStats["Smith Falls"]["quantity"]}
                                icon={{ color: "info", component: "inventory" }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MiniStatisticsCard
                                title={{ text: "Total Value SF" }}
                                count={`C$ ${inventoryStats["Smith Falls"]["value"]}`}
                                icon={{ color: "success", component: "attach_money" }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MiniStatisticsCard
                                title={{ text: "Total Products Kanata" }}
                                count={inventoryStats["Kanata"]["quantity"]}
                                icon={{ color: "info", component: "inventory" }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MiniStatisticsCard
                                title={{ text: "Total Value Kanata" }}
                                count={`C$ ${inventoryStats["Kanata"]["value"]}`}
                                icon={{ color: "success", component: "attach_money" }}
                            />
                        </Grid>
                    </Grid>)}

                <MDBox mt={3}>
                    <Grid container spacing={3}>

                        {/* Recent Changes */}
                        <Grid item xs={12} md={6}>
                            <RecentChanges />
                        </Grid>

                        {/* Stock Diversity */}
                        <Grid item xs={12} md={6}>
                            <StockDiversity />
                        </Grid>

                        {/* Awaiting Approval Section */}
                        <Grid item xs={12}>
                            <MDBox mt={3}>
                                <AwaitingApproval />
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox mt={6}>
                    <Footer />
                </MDBox>

            </MDBox>
        </DashboardLayout>
    )
}